import { apiRequest } from '@/core';

export type NotificationItem = {
  id: string;
  type: string;
  message: string;
  rendered_message?: Record<string, string>;
  message_params: Record<string, number | string | null>;
  meta: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string;
};

export type NotificationListResponse = {
  data: NotificationItem[];
  links: Record<string, string | null>;
  meta: {
    current_page: number;
    per_page: number;
    last_page: number;
    total: number;
    unread_count: number;
  };
};

export type UnreadCountResponse = {
  unread_count: number;
};

export const getNotifications = (page = 1, perPage = 15) =>
  apiRequest<NotificationListResponse>({
    endpoint: `/v1/notifications`,
    params: { page, per_page: perPage },
  });

export const getUnreadCount = () =>
  apiRequest<UnreadCountResponse>({
    endpoint: `/v1/notifications/unread-count`,
  });

export const markNotificationRead = (id: string) =>
  apiRequest<{ message: string }>({
    endpoint: `/v1/notifications/${id}/read`,
    method: 'PATCH',
  });

export const markNotificationUnread = (id: string) =>
  apiRequest<{ message: string }>({
    endpoint: `/v1/notifications/${id}/unread`,
    method: 'PATCH',
  });

export const markAllNotificationsRead = () =>
  apiRequest<{ message: string }>({
    endpoint: `/v1/notifications/read-all`,
    method: 'PATCH',
  });
